//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { BTab, BTabs, BModal } from 'bootstrap-vue'

import ProfileData from '~/components/profile/mixins/ProfileData'

export default {

    name: 'ProfileRightColumn',

    mixins: [ProfileData],

    components: { BTab, BTabs, BModal },

    props: {
        company: {
        },
        destination: {
        },
        internalVisit: {
        },
    },

    data() {
        return {
            tabIndex: 0,
            showProducts: false,
        }
    },

    methods: {

        getMapInfoText(location) {

            if(location.locality && !this.$helper.empty(location.locality) ) {
                return location.locality + ', ' + location.country
            }

            return location.country
        },

    },

    computed: {

        showDestinations() {

            if(this.company.isMasterProfile) {
                return true
            }

            if(this.company.hasDestination) {
                return true
            }

            return false
        },

        showKeyfacts() {

            if(this.company.showFactsBlock === true || this.isType('hotel')){
                return true
            }

            return false
        },

        activeTab() {
          return this.tabIndex
        },

        showSpacesRooms() {

            if(this.destination.hasSpacesOrRooms === false) {
                return false
            }

            if(this.destination.showServicesBlock === false && this.isType('event') === false) {
                return false
            }

            return true

        },

        showReferences() {

            if(this.company.verifiedMember === false) {
                return false
            }

            if(this.company.hasReferences === false) {
                return false
            }

            return true
        },

    },

}

